module.exports = __webpack_public_path__ + "img/person_pin_circle.fb72177a.svg";